// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,optimize_code_size,server_grpc1,long_type_number
// @generated from protobuf file "aware_proto/proto/Geometry.proto" (syntax proto3)
// tslint:disable
import { Empty } from "../../google/protobuf/empty";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
// @generated message type with reflection information, may provide speed optimized methods
class Point2$Type extends MessageType {
    constructor() {
        super("Point2", [
            { no: 1, name: "x", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "y", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message Point2
 */
export const Point2 = new Point2$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Point3$Type extends MessageType {
    constructor() {
        super("Point3", [
            { no: 1, name: "x", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "y", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "z", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message Point3
 */
export const Point3 = new Point3$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Quaternion$Type extends MessageType {
    constructor() {
        super("Quaternion", [
            { no: 1, name: "x", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "y", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "z", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "w", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message Quaternion
 */
export const Quaternion = new Quaternion$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Pose3$Type extends MessageType {
    constructor() {
        super("Pose3", [
            { no: 1, name: "position", kind: "message", T: () => Point3 },
            { no: 2, name: "orientation", kind: "message", T: () => Quaternion },
            { no: 3, name: "uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message Pose3
 */
export const Pose3 = new Pose3$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PixelPointPair$Type extends MessageType {
    constructor() {
        super("PixelPointPair", [
            { no: 1, name: "pixel", kind: "message", T: () => Point2 },
            { no: 2, name: "point", kind: "message", T: () => Point3 }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message PixelPointPair
 */
export const PixelPointPair = new PixelPointPair$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CameraIntrinsics$Type extends MessageType {
    constructor() {
        super("CameraIntrinsics", [
            { no: 1, name: "fx", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "fy", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "px", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "py", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "k1", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "k2", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "p1", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "p2", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "reference_width", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "reference_height", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message CameraIntrinsics
 */
export const CameraIntrinsics = new CameraIntrinsics$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ImageMetadata$Type extends MessageType {
    constructor() {
        super("ImageMetadata", [
            { no: 1, name: "f_stop", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "exposure_duration", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "iso", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "luminosity", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message ImageMetadata
 */
export const ImageMetadata = new ImageMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PosedCamera$Type extends MessageType {
    constructor() {
        super("PosedCamera", [
            { no: 1, name: "pose", kind: "message", T: () => Pose3 },
            { no: 2, name: "intrinsics", kind: "message", T: () => CameraIntrinsics }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message PosedCamera
 */
export const PosedCamera = new PosedCamera$Type();
/**
 * @generated ServiceType for protobuf service FakeServiceGeometry
 */
export const FakeServiceGeometry = new ServiceType("FakeServiceGeometry", [
    { name: "Bar", options: {}, I: Empty, O: Empty }
]);
